export const NavbarItems = [
  { name: 'Home', route: '/',fragment:'' },
  { name: 'Services', route: '/' , fragment:'services' },
  { name: 'Resources', route: '/resources' ,fragment:''},
  { name: 'Contact Us', route: '/contact-us' ,fragment:''},
];
